import React from "react";
import './time-list.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";

class TimeList extends React.Component {

    state = {
        // timeListHash: {
        //     "correct": [{
        //         "userName": "Countingwell School School International School",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "10.02",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "1.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "Countingwell School School International School",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.02",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     },
        //     {
        //         "userName": "58:2f:be:86:1c:ee",
        //         "userId": "659b90fa21cb4f53081b46a7",
        //         "timeTakenInMins": "0.03",
        //         "timeTakenToAnswer": 1405,
        //         "status": "CORRECT"
        //     }
        //     ]
        // }
        timeListHash: this.props.timeListHash
    }

    constructor(props) {
        super(props)
        console.log(this.props.leaderboardLimit)
    }


    ScoreDisplay = (timeList) => {
        if (!timeList.length) return (<div className="text-center no-leaderboard-text">No leaderboard</div>)

        if (timeList[0].status === "CORRECT") {
            timeList = timeList.sort((a, b) => a.timeTakenToAnswer - b.timeTakenToAnswer)
        }

        timeList.forEach(item => {
            let student = this.props.studentListHash[item.userId]
            item.userName = student.userName
            item.studentNumber = student.studentNumber
        })

        console.log(timeList, this.props.leaderboardLimit)


        let limit = this.props.leaderboardLimit === '5' ? 4 : this.props.leaderboardLimit === '10' ? 9 : this.props.leaderboardLimit === 'ALL' ? timeList.length ? timeList.length - 1 : 100 : 100

        if (this.props.leaderboardLimit === 'ALL' && timeList.length > 10) {
            return (
                timeList.length ?
                <div className="row mt-1" style={{marginLeft: "2rem"}}>
                    <div className="col">
                        {
                            timeList.slice(0, Math.ceil(timeList.length / 2)).map((item, index) => (
                                <>
                                    {

                                        <div className="score-item score-item-new row"
                                            key={index}
                                            style={{ backgroundColor: item.status === 'CORRECT' ? '#003478' : item.status === 'IN_CORRECT' ? "#FF6464" : "#FF9064" }}>
                                            <div className="col d-flex align-items-center"> <span className="shield"><span className="number">{index + 1}</span></span> <span className="name">{item.userName}{` (${item.studentNumber})`}</span></div>
                                            {
                                                item.timeTakenInMins && item.status === 'CORRECT' ?
                                                    <div className="score col-3"> <img className="clock-image-size" src={getImageSource(ImageConstants.NEW_BLACK_CLOCK_ICON)} /> {item.timeTakenInMins} s</div>
                                                    : <></>
                                            }
                                        </div>

                                    }
                                </>
                            ))
                        }
                    </div>
                    <div className="col">
                        {
                            timeList.slice(Math.ceil(timeList.length / 2)).map((item, index) => (
                                <>
                                    {

                                        <div className="score-item score-item-new row"
                                            key={index}
                                            style={{ backgroundColor: item.status === 'CORRECT' ? '#003478' : item.status === 'IN_CORRECT' ? "#FF6464" : "#FF9064" }}>
                                            <div className="col d-flex align-items-center"> <span className="shield"><span className="number">{index + 1 + Math.ceil(timeList.length / 2)}</span></span> <span className="name">{item.userName}{` (${item.studentNumber})`}</span></div>
                                            {
                                                item.timeTakenInMins && item.status === 'CORRECT' ?
                                                    <div className="score col-3"> <img className="clock-image-size" src={getImageSource(ImageConstants.NEW_BLACK_CLOCK_ICON)} /> {item.timeTakenInMins} s</div>
                                                    : <></>
                                            }
                                        </div>

                                    }
                                </>
                            ))
                        }
                    </div>
                </div>
                :
                <div className="text-center no-leaderboard-text">No Time leaderboard</div>
            )
        }

        return (
            <div className="score-board mt-1">
                {timeList.length ?
                    timeList.map((item, index) => (
                        <>
                            {
                                index <= limit ?
                                    <div className="score-item row"
                                        key={index}
                                        style={{ backgroundColor: item.status === 'CORRECT' ? '#003478' : item.status === 'IN_CORRECT' ? "#FF6464" : "#FF9064" }}>
                                        {/* <span className="rank">{index + 1}</span> */}
                                        <div className="col d-flex align-items-center"> <span className="shield"><span className="number">{index + 1}</span></span> <span className="name">{item.userName}{` (${item.studentNumber})`}</span></div>
                                        {/* <span className="d-flex align-items-center"> <span  className="shield"><span className="number">{index + 1}</span></span> <span className="name">{item.userName}{` (${item.studentNumber})`}</span></span> */}
                                        {
                                            item.timeTakenInMins && item.status === 'CORRECT' ?
                                                // <span className="score"> <img className="clock-image-size" src={getImageSource(ImageConstants.NEW_BLACK_CLOCK_ICON)} /> {item.timeTakenInMins} s</span> 
                                                <div className="score col-auto"> <img className="clock-image-size" src={getImageSource(ImageConstants.NEW_BLACK_CLOCK_ICON)} /> {item.timeTakenInMins} s</div>
                                                : <></>
                                        }
                                    </div>
                                    :
                                    <div className="text-center no-leaderboard-text"></div>
                            }
                        </>
                    ))
                    :
                    <div className="text-center no-leaderboard-text">No Time leaderboard</div>
                }
            </div>
        );
    };


    renderTimeList() {

        let timeListKeys = Object.keys(this.state.timeListHash)

        return (
            <div>
                {
                    // timeListKeys.map(item => ( // to Show only Correct Students
                    this.ScoreDisplay(this.state.timeListHash[timeListKeys[0]])
                    // ))
                }
            </div>
        )

    }


    render() {
        return (
            <div className="time-list-new">
                {this.renderTimeList()}
            </div>
        )
    }

}

export default TimeList;